// extracted by mini-css-extract-plugin
module.exports =  {"container":"jWnoAsz","large-spacing":"ommg6XT","largeSpacing":"ommg6XT","proposition-points":"HlJ2llK","propositionPoints":"HlJ2llK","point":"DWn90lc"};